export const CONNECTION_ERRORS = {
  PROVIDER_NOT_SUPPORTED: 'PROVIDER_NOT_SUPPORTED',
  NOT_AUTHORIZED: 'NOT_AUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
}
